import type { ReportFilters } from '../services/report.service';

export const REPORTS_DETAILED_FILTER_STORAGE_KEY = 'reports_filter_detailed_open';
export const USAGE_RECORDS_DETAILED_FILTER_STORAGE_KEY = 'usage_records_filter_detailed_open';

/** 空文字・null・false を落としたレポート用フィルター */
export function normalizeReportFilters(filters: ReportFilters): ReportFilters {
  return Object.fromEntries(
    Object.entries(filters).filter(([, value]) => {
      if (value === undefined || value === null) return false;
      if (typeof value === 'string' && value.trim() === '') return false;
      if (value === false) return false;
      return true;
    })
  ) as ReportFilters;
}

/** キーワード以外の詳細フィルター件数（バッジ表示用） */
export function countDetailedReportFilters(filters: ReportFilters): number {
  const { keyword: _keyword, ...rest } = filters;
  return Object.keys(normalizeReportFilters(rest)).length;
}
